import { useState } from "react";
import { useTranslation } from "react-i18next";
import Heading from "../../../component/Heading/Heading";

import CommonTabs from "../../../component/tabs/Tabs";
import LiquiditätsbilanzOne from "./TabLiquiditätsbilanz/LiquiditätsbilanzOne";
import LiquiditätsbilanzTwo from "./TabLiquiditätsbilanz/LiquiditätsbilanzTwo";
import "../../../styles/pages/customer/liquiditätsbilanz.scss";
import { useCommonContext } from "../../../context/common";
import SelectCustomerPage from "../select-customer/SelectCustomerPage";

const tabs = [
    { label: 'Liquiditätsbilanz |', translationKey: 'liquiditätsbilanz_tab_one' },
    { label: 'Liquiditätsbilanz ||', translationKey: 'liquiditätsbilanz_tab_two' },
];

const content = [
    <LiquiditätsbilanzOne />,
    <LiquiditätsbilanzTwo />
];

const Liquiditätsbilanz = () => {
    const { t } = useTranslation();
    const [value, setValue] = useState(0);
    const { clientId } = useCommonContext();

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    if (!clientId) {
        return <SelectCustomerPage />
    }

    return (
        <div className="liquiditätsbilanz">
            <div>
                <div className="flex justify-between">
                    <Heading text={t('liquiditätsbilanz_heading')} />
                </div>
                <div className="liquiditätsbilanz-border">
                    <CommonTabs
                        value={value}
                        onChange={handleChange}
                        tabs={tabs}
                        content={content}
                    />
                </div>
            </div>
        </div>
    )
}

export default Liquiditätsbilanz;
